const unsupportedNode = require('./helper').unsupportedNode;

module.exports = unsupportedNode('Boundary events ignored by execution engine','bpmn:BoundaryEvent');
